import { styled } from '@linaria/react';

import { normalize, range } from '@/utils';
import {
  convertHSLToLCH,
  convertHSLToRGB,
} from '@/helpers/color.helpers';

interface Props {
  variant?: 'original' | 'fixed';
  numOfStops: number;
  fromColor: [number, number, number];
  toColor: [number, number, number];
}

function ColorBricksArray({
  numOfStops,
  fromColor,
  toColor,
  variant = 'original',
}: Props) {
  return (
    <Wrapper data-variant={variant}>
      {range(numOfStops).map((i) => {
        let color;

        if (variant === 'original') {
          const fromColorRGB = convertHSLToRGB(...fromColor);
          const toColorRGB = convertHSLToRGB(...toColor);

          color = `rgb(
            ${normalize(
              i,
              0,
              numOfStops,
              fromColorRGB[0],
              toColorRGB[0]
            )}
            ${normalize(
              i,
              0,
              numOfStops,
              fromColorRGB[1],
              toColorRGB[1]
            )}
            ${normalize(
              i,
              0,
              numOfStops,
              fromColorRGB[2],
              toColorRGB[2]
            )}
          )`;
        } else if (variant === 'fixed') {
          const fromColorLCH = convertHSLToLCH(...fromColor);
          const toColorLCH = convertHSLToLCH(...toColor);

          color = `lch(
            ${normalize(
              i,
              0,
              numOfStops,
              fromColorLCH[0],
              toColorLCH[0]
            )}
            ${normalize(
              i,
              0,
              numOfStops,
              fromColorLCH[1],
              toColorLCH[1]
            )}
            ${normalize(
              i,
              0,
              numOfStops,
              fromColorLCH[2],
              toColorLCH[2]
            )}
          )`;
        }

        return (
          <BrickWrapper key={i}>
            <Brick style={{ background: color }} />
          </BrickWrapper>
        );
      })}
      {variant === 'original' && (
        <Highlight>
          <svg
            width="84"
            height="60"
            viewBox="0 0 84 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M82.5369 3.40062C83.3104 3.1041 83.6971 2.23664 83.4006 1.4631C83.1041 0.689558 82.2366 0.30286 81.4631 0.599383L82.5369 3.40062ZM10.4374 59.5606C11.0232 60.1464 11.9729 60.1465 12.5587 59.5607L22.1047 50.0148C22.6905 49.429 22.6905 48.4793 22.1048 47.8935C21.519 47.3077 20.5692 47.3077 19.9834 47.8935L11.4981 56.3787L3.01287 47.8933C2.42709 47.3075 1.47734 47.3075 0.891552 47.8933C0.30576 48.4791 0.30575 49.4288 0.891531 50.0146L10.4374 59.5606ZM82 2L81.4631 0.599383C74.3283 3.3344 66.4915 2.97596 58.4922 2.09495C50.6332 1.22941 42.4722 -0.175715 35.2919 0.826913C31.6475 1.3358 28.1784 2.46718 25.0443 4.62722C21.9075 6.7891 19.1858 9.92667 16.9572 14.3305C12.5283 23.0824 9.99826 36.9354 9.99805 58.5L11.498 58.5L12.998 58.5C12.9983 37.0646 15.5312 23.7926 19.634 15.6851C21.6713 11.6593 24.0825 8.93356 26.7467 7.09739C29.4136 5.25938 32.4135 4.25795 35.7068 3.79809C42.4019 2.86322 49.9912 4.17684 58.1637 5.07692C66.1959 5.96154 74.6717 6.4156 82.5369 3.40062L82 2Z"
              fill="currentColor"
            />
          </svg>
          <Guy>🤔</Guy>
        </Highlight>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  gap: 4px;
  margin-bottom: 64px;
  margin-top: 8px;

  &[data-variant='original'] {
    margin-top: 96px;
  }
`;

const BrickWrapper = styled.div`
  position: relative;
  flex: 1;
`;
const Brick = styled.div`
  height: 100px;
  border-radius: 4px;
`;

const Highlight = styled.div`
  position: absolute;
  top: -16px;
  left: calc(50% - 12px);
  display: flex;
  align-items: flex-start;
  font-size: 32px;
  transform: translateY(-100%);
`;

const Guy = styled.div`
  transform: translate(8px, -60%);
`;

export default ColorBricksArray;
